import { validateRequired, validateLength,validateNotNull } from "../../../../helpers/validationsForm";

const Inputs = (selectViewValue) => {

  return [
    {
      id: 1,
      label: "Nombre del deposito",
      name: "depo_descripcion",
      type: "text",
      placeholder: "Ingrese el nombre del deposito",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 3, maxLength: 60 });
      }
    },
    {
      id: 2,
      label: "Seleccione la sucursal",
      name: "depo_suc_id",
      type: "text",
      placeholder: "Ingrese el teléfono",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 7, maxLength: 20 });
      }
    },

    {
      id: 3,
      label: "Dirección",
      name: "depo_direccion",
      type: "text",
      placeholder: "Ingrese la dirección",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 5, maxLength: 100 });
      }
    },

  ];
};

export default Inputs;
